import Vue from 'vue'
import App from './App.vue'
import Element from 'element-ui';
import router from './router'
import  'element-ui/lib/theme-chalk/index.css'
import VueImgmode from 'vue-imgmode'
import vueEsign from 'vue-esign'
import Print from 'vue-print-nb'


Vue.use(vueEsign)
Vue.use(VueImgmode)
Vue.use(Element);
Vue.use(Print);


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
